import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-45707e57"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "relative shrink-0 rounded-t-sm h-10 flex items-center justify-center px-4" };
var _hoisted_2 = { class: "py-1 flex items-center" };
var _hoisted_3 = { class: "mr-2 text-gray-500" };
var _hoisted_4 = { class: "w-12" };
var _hoisted_5 = { class: "ml-2" };
import { onMounted, onBeforeUnmount, ref, computed } from 'vue';
import fullscreen from '@common/utils/Fullscreen';
import * as PDFJS from 'pdfjs-dist';
import { VuePDF, usePDF } from '@tato30/vue-pdf/packages/vue-pdf';
import '@tato30/vue-pdf/packages/vue-pdf/dist/style.css';
import { PdfViewerStore } from '@common/stores';
import EInputNumber from '@common/ui/EInputNumber.vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EPdfViewer',
    props: {
        src: {},
        enableTextSelection: { type: Boolean, default: true },
        enableAnnotations: { type: Boolean, default: true },
        fitByHeight: { type: Boolean, default: false }
    },
    emits: [
        'test',
        'focusin',
        'focusout'
    ],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var emit = __emit;
        var props = __props;
        var t = useI18n().t;
        // Для легаси браузеров используем legacy worker
        // Как указано в документации, полифиллы не помогут, так как worker запускается в отдельном потоке
        PDFJS.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@5.2.133/legacy/build/pdf.worker.min.mjs';
        var loading = ref(false);
        var root = ref(null);
        var wrapper = ref(null);
        var vuePdf = ref(null);
        var totalPages = ref(1);
        var currentPage = ref(1);
        var currentPageInPdf = ref(1);
        var inputPage = ref(1);
        var isFullscreen = ref(false);
        var pageHeight = ref(null);
        var resizeObserver;
        var pdfViewerStore = PdfViewerStore;
        var isRendered = ref(false);
        // Create a computed property for the PDF source to make it reactive
        var pdfSrc = computed(function () { return props.src; });
        // Use the usePDF composable to load the PDF document
        var pdf = usePDF(pdfSrc, {
            onError: function (error) {
                console.error('EPdfViewer.vue: pdf loading failed', error);
                console.error('PDF source was:', pdfSrc.value);
                loading.value = false;
            }
        }).pdf;
        var onPdfLoaded = function () {
            loading.value = false;
            // Get total pages from the pdf object
            pdf.value.promise.then(function (doc) {
                totalPages.value = doc.numPages;
            }).catch(function (error) {
                console.error('EPdfViewer.vue: Error getting total pages', error);
            });
        };
        var openPage = function (number) {
            if (typeof number === 'string') {
                number = parseInt(number);
            }
            // Не пропускаем некорректные значения
            if (isNaN(number) || number > totalPages.value || number <= 0) {
                return;
            }
            currentPage.value = number;
            inputPage.value = number;
            currentPageInPdf.value = number;
        };
        var prevPage = function (e) {
            var page = currentPage.value;
            if (page > 1) {
                currentPage.value = page - 1;
                openPage(currentPage.value);
            }
            e === null || e === void 0 ? void 0 : e.preventDefault();
        };
        var nextPage = function (e) {
            var page = currentPage.value;
            if (page < totalPages.value) {
                currentPage.value = page + 1;
                openPage(currentPage.value);
            }
            e === null || e === void 0 ? void 0 : e.preventDefault();
        };
        var toggleFullscreen = function () {
            if (fullscreen.isEnabled) {
                fullscreen.toggle(root.value);
            }
            else {
                if (pdfViewerStore.src === null) {
                    pdfViewerStore.show(props.src);
                }
                else {
                    pdfViewerStore.hide();
                }
            }
        };
        var onFullscreenChange = function () {
            isFullscreen.value = fullscreen.isFullscreen && document.fullscreenElement === root.value ? true : false;
        };
        // Функция rerenderPdf больше не нужна, так как VuePDF автоматически обновляется
        var onComponentFocus = function () {
            emit('focusin');
        };
        var onComponentFocusout = function () {
            emit('focusout');
        };
        /**
         * Обновляем высоту страницы под доступную высоту wrapper
         * (используется только если fitByHeight === true)
         */
        var updatePageHeight = function () {
            if (!props.fitByHeight)
                return;
            if (!wrapper.value)
                return;
            pageHeight.value = wrapper.value.clientHeight;
            if (vuePdf.value && typeof vuePdf.value.reload === 'function') {
                vuePdf.value.reload();
            }
        };
        /**
         * Handle keyboard events for navigation
         * @param {KeyboardEvent} event - The keyboard event
         */
        var handleKeyDown = function (event) {
            // Only handle keyboard events when the component is focused
            if (document.activeElement !== root.value) {
                return;
            }
            // Handle left arrow key for previous page
            if (event.key === 'ArrowLeft') {
                prevPage(event);
            }
            // Handle right arrow key for next page
            else if (event.key === 'ArrowRight') {
                nextPage(event);
            }
        };
        onMounted(function () {
            if (isRendered.value) {
                return;
            }
            loading.value = true;
            initializeEventListeners();
            if (props.fitByHeight) {
                updatePageHeight();
            }
            isRendered.value = true;
        });
        var handleViewportChange = function () {
            // даём layout'у устаканиться
            requestAnimationFrame(function () {
                if (props.fitByHeight) {
                    updatePageHeight();
                }
                else {
                    if (vuePdf.value && typeof vuePdf.value.reload === 'function') {
                        vuePdf.value.reload();
                    }
                }
            });
        };
        var initializeEventListeners = function () {
            if (!root.value)
                return;
            if (props.fitByHeight) {
                // следим за wrapper, обновляем высоту
                if (wrapper.value) {
                    resizeObserver = new ResizeObserver(function () {
                        updatePageHeight();
                    });
                    resizeObserver.observe(wrapper.value);
                }
            }
            else {
                // Обновляем PDF при изменении размера окна
                resizeObserver = new ResizeObserver(function () {
                    // Вызываем метод reload() у компонента VuePDF
                    if (vuePdf.value && typeof vuePdf.value.reload === 'function') {
                        vuePdf.value.reload();
                    }
                });
                resizeObserver.observe(root.value);
            }
            if (fullscreen.isEnabled) {
                fullscreen.on('change', onFullscreenChange, root.value);
            }
            if (window !== undefined) {
                window.addEventListener('resize', handleViewportChange);
                window.addEventListener('orientationchange', handleViewportChange);
            }
            root.value.addEventListener('focus', onComponentFocus);
            root.value.addEventListener('focusout', onComponentFocusout);
        };
        onBeforeUnmount(function () {
            var _a, _b;
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
            if (fullscreen.isEnabled) {
                fullscreen.off('change', onFullscreenChange);
            }
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', handleViewportChange);
                window.removeEventListener('orientationchange', handleViewportChange);
            }
            (_a = root.value) === null || _a === void 0 ? void 0 : _a.removeEventListener('focus', onComponentFocus);
            (_b = root.value) === null || _b === void 0 ? void 0 : _b.removeEventListener('focusout', onComponentFocusout);
        });
        /** Классы для разных режимов */
        var fitByHeightClass = computed(function () {
            return props.fitByHeight ? 'e-pdf-viewer--fit-height' : '';
        });
        var wrapperClass = computed(function () {
            return props.fitByHeight
                ? 'e-pdf-viewer--wrapper e-pdf-viewer--wrapper-fit-height items-center justify-center flex'
                : 'e-pdf-viewer--wrapper overflow-y-auto';
        });
        return function (_ctx, _cache) {
            var _component_e_icon = _resolveComponent("e-icon");
            var _component_e_button = _resolveComponent("e-button");
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "root",
                ref: root,
                class: _normalizeClass([[
                        isFullscreen.value ? 'e-pdf-viewer--fullscreen' : 'rounded-lg',
                        fitByHeightClass.value
                    ], "e-pdf-viewer border-2 border-gray-200 bg-gray-200 overflow-hidden"]),
                tabindex: "0",
                onKeydown: handleKeyDown
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_e_button, {
                        class: "mr-5 py-2 px-4 hover:bg-gray-300 rounded-lg",
                        size: "nosize",
                        type: "text",
                        onClick: prevPage
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: "text-gray-500 w-2 h-4",
                                icon: "angle-left"
                            })
                        ]; }),
                        _: 1
                    }),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('pdfViewer.page')), 1),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(EInputNumber, {
                                modelValue: inputPage.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((inputPage).value = $event); }),
                                max: totalPages.value,
                                min: 1,
                                size: "small",
                                onChange: openPage
                            }, null, 8, ["modelValue", "max"])
                        ]),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('pdfViewer.of')) + " " + _toDisplayString(totalPages.value), 1)
                    ]),
                    _createVNode(_component_e_button, {
                        class: "ml-5 py-2 px-4 hover:bg-gray-300 rounded-lg",
                        size: "nosize",
                        type: "text",
                        onClick: nextPage
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: "text-gray-500 w-2 h-4",
                                icon: "angle-right"
                            })
                        ]; }),
                        _: 1
                    }),
                    _createVNode(_component_e_button, {
                        class: "absolute top-0 right-0 h-full w-12 hover:bg-gray-300",
                        size: "nosize",
                        type: "text",
                        onClick: toggleFullscreen
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_e_icon, {
                                class: "w-4 h-4 text-gray-500",
                                icon: "fullscreen"
                            })
                        ]; }),
                        _: 1
                    })
                ]),
                _createElementVNode("div", {
                    ref_key: "wrapper",
                    ref: wrapper,
                    class: _normalizeClass([wrapperClass.value, "overflow-y-auto"])
                }, [
                    _createVNode(_unref(VuePDF), {
                        ref_key: "vuePdf",
                        ref: vuePdf,
                        "annotation-layer": _ctx.enableAnnotations,
                        "fit-parent": !props.fitByHeight,
                        height: (props.fitByHeight && pageHeight.value) ? pageHeight.value : undefined,
                        page: currentPageInPdf.value,
                        pdf: _unref(pdf),
                        "text-layer": _ctx.enableTextSelection,
                        onLoaded: onPdfLoaded
                    }, null, 8, ["annotation-layer", "fit-parent", "height", "page", "pdf", "text-layer"])
                ], 2)
            ], 34));
        };
    }
});
